import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { CircularProgress, Box } from '@mui/material'
import { useAuth } from '../../contexts/AuthContext'

interface AdminGuardProps {
  children: ReactNode
}

const AdminGuard = ({ children }: AdminGuardProps) => {
  const { isAuthenticated, isAdmin, loading } = useAuth()

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (!isAuthenticated) {
    // Przekieruj na stronę logowania, jeśli użytkownik nie jest uwierzytelniony
    return <Navigate to="/login" replace />
  }

  if (!isAdmin) {
    // Przekieruj na stronę projektów, jeśli użytkownik nie jest administratorem
    return <Navigate to="/projects" replace />
  }

  return <>{children}</>
}

export default AdminGuard